import { render, staticRenderFns } from "./SearchedSuggestion.vue?vue&type=template&id=2c815c96&"
import script from "./SearchedSuggestion.vue?vue&type=script&lang=js&"
export * from "./SearchedSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports